function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SpinnerTypes } from '../infrastructure/const';
import LogoData from '../configuration/logo-data';
// import Logger from '../../../../wdh-logger/wdh-logger';

/**
 * Component to add a spinner to a component
 * @memberOf module:wdh-feature-b2b
 * @example
 * import Spinner from 'wdh-feature-b2b/src/js/components/spinner';
 * <Spinner
      show={this.state.showSpinner}
    />
 */
var Spinner = /*#__PURE__*/function (_React$Component) {
  /**
   * @constructor
   * @param {BoolString} props.show   True to show the spinner, false to hide it
   */
  function Spinner(props) {
    var _this;
    _classCallCheck(this, Spinner);
    _this = _callSuper(this, Spinner, [props]);
    _this.state = {
      internalShow: false
    };
    _this.showPropertyHasBeenReset = false;

    /**
     * The existing overflow setting of the spinner's parent node
     * @private
     * @type {Object}
     */
    _this.parentOverflowOriginal = null;

    /**
     * Ref to the root node
     * @private
     * @type {Object}
     */
    _this.rootNode = /*#__PURE__*/React.createRef();
    _this.containerNode = /*#__PURE__*/React.createRef();
    _this.scrollHandler = _this.scrollHandler.bind(_this);
    _this.loaderImagePositionTypes = {
      // center loader image in loading block
      centerInLoadingBlock: 'centerInLoadingBlock',
      // let loader image follow visible window (when scrolled)
      moveWithWindowScrolling: 'moveWithWindowScroll'
    };
    _this.loaderImagePositionType = null;
    return _this;
  }
  _inherits(Spinner, _React$Component);
  return _createClass(Spinner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setVisibility(this.props);
      if (this.props.centerInsideParent) {
        this.setLoaderImagePosition();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.show !== this.props.show) {
        this.setVisibility(nextProps);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.centerInsideParent) {
        this.setLoaderImagePosition();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.scrollHandler);
    }
  }, {
    key: "setVisibility",
    value: function setVisibility(props) {
      var _this2 = this;
      if (props.show === false) {
        // show property was set to false
        // prevent showing (cancel)
        this.showPropertyHasBeenReset = true;
        if (props.show !== this.state.internalShow) {
          // stop showing
          this.setState({
            internalShow: props.show
          });
        }
      } else if (props.show !== this.state.internalShow) {
        // show property changed from false to true
        // start waiting to show
        this.showPropertyHasBeenReset = false;
        setTimeout(function () {
          // check if canceled
          if (!_this2.showPropertyHasBeenReset) {
            // show
            _this2.setState({
              internalShow: props.show
            });
          } else {
            // do not show spinner (canceled)
          }
        }, this.props.delayBeforeShow);
      }
    }
  }, {
    key: "setPositionAndParentProps",
    value: function setPositionAndParentProps() {
      var spinnerNode = this.rootNode && this.rootNode.current ? this.rootNode.current : null;
      var parent = null;
      if (this.props.parentInfo.spinnerType === SpinnerTypes.MOVEINTOPARENT && this.props.parentInfo.parent.current) {
        parent = this.props.parentInfo.parent.current;
        if (spinnerNode) {
          parent.appendChild(spinnerNode);
        }
      } else if (spinnerNode) {
        parent = spinnerNode.parentNode;
      }
      if (parent) {
        var cssPosition = getComputedStyle(parent).position;
        if (cssPosition.indexOf('absolute') === -1 && cssPosition.indexOf('relative') === -1) {
          parent.style.position = 'relative';
        }
        var parentOverflow = parent.style.overflow;
        if (this.parentOverflowOriginal === null) {
          this.parentOverflowOriginal = parentOverflow;
        }
        if (this.state.internalShow) {} else if (parentOverflow !== this.parentOverflowOriginal) {
          parent.style.overflow = this.parentOverflowOriginal;
        }
        this.loaderImagePositionType = parent.offsetHeight > window.innerHeight / 4 * 3 ? this.loaderImagePositionTypes.moveWithWindowScrolling : this.loaderImagePositionTypes.centerInLoadingBlock;
        if (this.loaderImagePositionType === this.loaderImagePositionTypes.moveWithWindowScrolling) {
          window.addEventListener('scroll', this.scrollHandler);
        } else {
          window.removeEventListener('scroll', this.scrollHandler);
        }
      }
    }
  }, {
    key: "setLoaderImagePosition",
    value: function setLoaderImagePosition() {
      if (this.loaderImagePositionType === this.loaderImagePositionTypes.moveWithWindowScrolling) {
        var bottomOfLoadingBlock = this.rootNode.current.parentNode.offsetHeight - this.containerNode.current.offsetHeight;
        var towardsTopOfLoadingBlock = window.pageYOffset + window.innerHeight / 4;
        var topPosition = Math.min(towardsTopOfLoadingBlock, bottomOfLoadingBlock);
        this.containerNode.current.style.top = "".concat(topPosition, "px");
      }
    }
  }, {
    key: "scrollHandler",
    value: function scrollHandler() {
      this.setLoaderImagePosition();
    }
  }, {
    key: "renderSpinner",
    value: function renderSpinner() {
      var spinnerClasses = classNames({
        'wdh-feature-b2b-spinner': true,
        'section-spinner': true,
        'dimmed-section': this.props.isSectionDimmed,
        show: this.state.internalShow
      });
      return /*#__PURE__*/React.createElement("div", {
        className: spinnerClasses,
        ref: this.rootNode
      }, /*#__PURE__*/React.createElement("div", {
        className: 'gear-container',
        ref: this.containerNode
      }, /*#__PURE__*/React.createElement("img", {
        src: LogoData.spinnerGreyImage,
        alt: "loader"
      }), /*#__PURE__*/React.createElement("img", {
        src: LogoData.spinnerPinkImage,
        alt: "loader"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.centerInsideParent) {
        this.setPositionAndParentProps();
      }
      var html = this.renderSpinner();
      return html;
    }
  }]);
}(React.Component);
Spinner.propTypes = {
  show: PropTypes.bool,
  isSectionDimmed: PropTypes.bool,
  parentInfo: PropTypes.oneOfType([PropTypes.shape({
    // spinnerType must be SpinnerTypes.ISALREADYINSIDEPARENT
    spinnerType: PropTypes.oneOf([0]).isRequired
  }), PropTypes.shape({
    // spinnerType must be SpinnerTypes.MOVEINTOPARENT
    spinnerType: PropTypes.oneOf([1]).isRequired,
    parent: PropTypes.instanceOf(Object).isRequired
  })]),
  delayBeforeShow: PropTypes.number,
  centerInsideParent: PropTypes.bool
};
Spinner.defaultProps = {
  show: false,
  isSectionDimmed: true,
  parentInfo: {
    spinnerType: SpinnerTypes.ISALREADYINSIDEPARENT
  },
  // ammount of milliseconds to wait before showing spinner
  delayBeforeShow: 10,
  centerInsideParent: true
};
export default Spinner;